$(function(){
  if($('.pointWrap').length){
    $(document).on('click', '.pointWrap .accordion', function() {
      $(this).toggleClass('open');
      $('.accountFlexWrap .historyWrap').slideToggle(400,function(){
        if(window.innerWidth < 768){
          var hh = $('.historyWrap').outerHeight(true);
          if ($('.historyWrap').css('display') == 'none') {
            $('.frcp-app').css({'padding-top':'0px'});
          }else{
            $('.frcp-app').css({'padding-top':hh+'px'});
          }
        }else{
          $('.frcp-app').css({'padding-top':'0px'});
        }
      });
    });
    $(window).resize(function() {
      if ($('.historyWrap').css('display') == 'none') {
        $('.frcp-app').css({'padding-top':'0px'});
      }else{
        if(window.innerWidth < 768){
          var hh = $('.historyWrap').outerHeight(true);
          $('.frcp-app').css({'padding-top':hh+'px'});
        }else{
          $('.frcp-app').css({'padding-top':'0px'});
        }
      }
    });
  }


  //会員登録の解除はこちら
  if($('.unregisterLink').length){
    var unregisterLink =  $(".unregisterLink").clone();
    if($('.historyWrap').length){
      $('.historyWrap').append(unregisterLink);
    }
    if($('.customer.addresses').length){
      $('.frcp-nav.frcp-nav--slider-menu,.frcp-app').append(unregisterLink);
    }
  }


  //アカウントの詳細に戻る
  if($('.back_to_details').length){
    var back_to_details =  $(".back_to_details").clone();
    $('.frcp-nav.frcp-nav--slider-menu,.frcp-app').append(back_to_details);
    
    $('.frcp-section__title').each(function(){
      if($.trim($(this).text()) == '住所'){
        $(this).addClass('account_title');
      }
    });
    
    $('.frcp-nav__menu span[data-to="#/profile"]').trigger("click");
    
    $(document).on('click', '.frcp-address__action.frcp-address__edit', function() {
      setTimeout(function() {
        var position = $('.frcp-container.frcp-main-view').offset().top;
        if(window.innerWidth>768){
           position = position - $('header.header').outerHeight(true) - 20;
        }else{
           position = position - $('.frcp-nav__menu').outerHeight(true) - 20;
        }
        $('body,html').animate({scrollTop:position}, 300, 'swing');

      }, 100);
    });
  }
  
  
  if($('.customer.account').length){
    
    $('.historyWrap_scroll').on('mouseover', function() {
      $('.historyWrap_scroll').addClass('on_scroll');
    })
    .on('mouseout', function() {
      $('.historyWrap_scroll').removeClass('on_scroll');
    });
    $('.historyWrap_scroll').on('touchmove', function() {
      $('.historyWrap_scroll').addClass('on_scroll');
    })
    .on('touchend', function() {
      $('.historyWrap_scroll').removeClass('on_scroll');
    });
    
    
  }
  
});